import { BaserowPlugin } from '@baserow/modules/core/plugins'
import DatabaseDashboardResourceLinks from '@baserow/modules/database/components/dashboard/DatabaseDashboardResourceLinks'
import AllTasksHeader from '@baserow/modules/database/components/table/AllTasksHeader'

export class DatabasePlugin extends BaserowPlugin {
  static getType() {
    return 'database'
  }

  getDashboardResourceLinksComponent() {
    return DatabaseDashboardResourceLinks
  }

  /**
   * Origem Flow: extras da toolbar da tabela "Todas as tarefas" (o próprio
   * componente some nas tabelas comuns).
   */
  getAdditionalTableHeaderComponents(view, isPublic) {
    if (isPublic) {
      return []
    }
    return [AllTasksHeader]
  }
}
